import React from 'react';
import { GroupOutlined, ToolOutlined } from '@ant-design/icons';

import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import IBDIcon from '@totem/styles/Icon';
import { ContractedServices } from '@totem/types/contractedServices';
import { UserProfile } from '@totem/types/user';

export const getSubMenuServices = (
  userProfile: UserProfile,
  contractedServices?: ContractedServices,
) => {
  const items: IBMenuItem[] = [
    {
      key: 'assetInventory',
      title: 'Asset Inventory',
      description: 'Asset Inventory',
      route: '/dashboard/assetInventory',
      label: 'Asset Inventory',
      icon: <IBDIcon name="Asset Inventory" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.assetInventory.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'backups',
      title: 'Backups',
      description: 'Backups',
      route: '/dashboard/deviceBackups',
      label: 'Backups',
      icon: <IBDIcon name="Backups" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.continuity.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'backupDashboard',
      title: 'Backup Dashboard',
      label: 'Backup Dashboard',
      description: 'Backup Dashboard',
      route: '/dashboard/backupDashboard',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.internal.hasPermissions(userProfile);
      },
    },
    {
      key: 'remoteAccessUsers',
      title: 'Remote Access',
      description: 'Remote Access Governance',
      route: '/dashboard/remoteAccessUsers',
      label: 'Remote Access',
      icon: <IBDIcon name="Remote Access" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.remoteAccess.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'optimize',
      title: 'Optimize',
      description: 'Opportunities for Savings',
      route: '/dashboard/optimize3',
      label: 'Optimize',
      icon: <IBDIcon name="Optimize" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.optimize.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'events',
      title: 'Events',
      description: 'Events Dashboard',
      route: '/dashboard/events',
      label: 'Events',
      icon: <IBDIcon name="Event" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.events.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'uniFi',
      title: 'UniFi',
      description: 'UniFi Hosts',
      route: '/dashboard/ubiquiti/hosts',
      label: 'UniFi',
      icon: <IBDIcon name="Device" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.uniFiService.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
          contractedServices,
        );
      },
    },
    {
      key: 'endOfSupport',
      title: 'End-of-Support',
      description: 'End-of-Support',
      route: '/dashboard/devices/endOfSupport',
      label: 'End-of-Support',
      icon: <IBDIcon name="EndOfSupport" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return (
          permissions.internal.hasPermissions(
            chkProfile,
            securityGroupCheckConstraintAny,
          ) ||
          permissions.devices.hasPermissions(
            chkProfile,
            securityGroupCheckConstraintAny,
          )
        );
      },
    },
    {
      key: 'maintenanceWindows',
      title: 'Maintenance Windows',
      description: 'Schedule Maintenance',
      route: '/dashboard/maintenanceWindows',
      label: 'Maintenance Windows',
      icon: <ToolOutlined />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.maintenanceWindowViewer.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
